import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-logo-yz",
  "use": "icon-logo-yz-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-logo-yz\">\n  <defs>\n    <linearGradient id=\"icon-logo-yz_bgGradient\" x1=\"0%\" y1=\"0%\" x2=\"100%\" y2=\"100%\">\n      <stop offset=\"0%\" style=\"stop-color:#3b6ff5\" />\n      <stop offset=\"100%\" style=\"stop-color:#5b8af7\" />\n    </linearGradient>\n  </defs>\n  <rect x=\"0\" y=\"0\" width=\"200\" height=\"200\" rx=\"36\" ry=\"36\" fill=\"url(#icon-logo-yz_bgGradient)\" />\n  <text x=\"100\" y=\"150\" font-family=\"Arial,Helvetica,sans-serif\" font-size=\"130\" font-weight=\"bold\" fill=\"white\" text-anchor=\"middle\">YZ</text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logo-yz.svg
// module id = FO9e
// module chunks = 65